// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__0G1aB","avatar__initials":"Avatar_avatar__initials__Sg-e6"};